export const getInitialData = () => {
  const timestamp = Math.floor(Date.now() / 1000) * 1000;
  const currentYear = new Date(timestamp).getFullYear();
  return {
    currentYear,
  };
};
